import { useState } from '@wordpress/element';
import {
    Popover,
    __experimentalToolsPanel as ToolsPanel,
    __experimentalToolsPanelItem as ToolsPanelItem,
    __experimentalHStack as HStack,
    __experimentalVStack as VStack,
    __experimentalText as Text,
    Button,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const animationOptions = [
    { name: 'none', className: 'vb-adv-ani-none' },
    { name: 'pointer', className: 'vb-adv-ani-pointer' },
    { name: 'help', className: 'vb-adv-ani-help' },
    { name: 'wait', className: 'vb-adv-ani-wait' },
    // { name: 'crosshair', className: 'vb-adv-ani-crosshair' },
    // { name: 'text', className: 'vb-adv-ani-text' },
    { name: 'not-allow', className: 'vb-adv-ani-not-allowed' },
    { name: 'grab', className: 'vb-adv-ani-grab' },
    { name: 'zoom-in', className: 'vb-adv-ani-zoom-in' },
    { name: 'cell', className: 'vb-adv-ani-cell' },
    // { name: 'copy', className: 'vb-adv-ani-copy' },
    { name: 'move', className: 'vb-adv-ani-move' },
    { name: 'alias', className: 'vb-adv-ani-alias' },
    { name: 'press', className: 'vb-adv-ani-press' },
    { name: 'float', className: 'vb-adv-ani-float' },
    { name: 'bounce', className: 'vb-adv-ani-bounce' },
];

export const VayuBlocksAdvAniMation = ({ animationData, onChange }) => {

    const animationvalue = animationData?.value;

    const [isVisible, setIsVisible] = useState(false);
    const [popoverAnchor, setPopoverAnchor] = useState();

    const toggleVisible = () => setIsVisible((prev) => !prev);

    const handleAnimationClick = (name) => {
        const selectedOption = animationOptions.find((opt) => opt.name === name);
        onChange(animationData.dataKey, {
            ...animationData.value,
            aniName: name,
            className: selectedOption?.className || '',
        });
        setIsVisible(false);
    };
    
    const resetAll = () => {
        handleAnimationClick('none');
    };

    return (
        <div className="vayu_blocks_animation_panel vb-adv-ani-panel">
            <ToolsPanel
                label={__('Hover Animation')}
                className="vayu_block_animation_name"
                resetAll={resetAll}
            >
                <ToolsPanelItem
                    className="vayu_blocks_animation_toolspanel_item"
                    hasValue={() => !!animationvalue?.aniName && animationData.value.aniName !== 'none'}
                    label={__('Hover Animation', 'vayu-blocks')}
                    onDeselect={() => handleAnimationClick('none')}
                    isShownByDefault
                >
                    <Button
                        ref={setPopoverAnchor}
                        onClick={toggleVisible}
                        className={`block-editor-panel-animation-settings__dropdown ${isVisible ? 'is-open' : ''}`}
                    >
                        <HStack  alignment="left">
                            {animationvalue?.aniName === 'none' || !animationvalue?.aniName ? (
                                <div className="vayu-blocks-panel-ihover vayu-blocks-none-button vayu_blocks_none" />
                            ) : (
                                <div
                                    className={`vayu_blocks_hstack_animation_panel_image vayu_blocks_hstack_animation_panel_image_color ${animationData.value.className}`}
                                />
                            )}
                            <Text>
                                {__(animationvalue?.aniName || 'Animation', 'vayu-blocks')}
                            </Text>
                        </HStack>
                    </Button>
                </ToolsPanelItem>
            </ToolsPanel>

            {isVisible && (
                <Popover
                    placement="left-start"
                    className="vayu_blocks_toolspanel_items_popover vb-ani-panel"
                    anchor={popoverAnchor}
                    onClose={() => setIsVisible(false)}
                    offset={35}
                    resize
                >
                    <VStack style={{ padding: '10px', width: '280px' }}>
                        <div>
                            <h4>{__('Hover Animation', 'vayu-blocks')}</h4>
                            <p>{__('Select an animation for your element.', 'vayu-blocks')}</p>
                        </div>

                        <HStack justify="flex-start" spacing ={1} wrap={true}>
                            {animationOptions.map(({ name, className }) => (
                                name === 'none' ? (
                                    <div
                                        key={name}
                                        className={`vayu-blocks-ihover-main-panel ${className} ${animationvalue?.aniName === name ? 'none-selected' : ''}`}
                                        onClick={() => handleAnimationClick(name)}
                                        title={name}
                                    >
                                        <div key={name} className="vayu-blocks-panel-ihover vayu-blocks-none-button vayu_blocks_none"/>
                                        <span className="vb-name-hover">{name}</span>
                                    </div>
                                ) : (
                                    <div
                                        key={name}
                                        className={`vayu-blocks-ihover-main-panel ${className} ${animationvalue?.aniName === name ? 'selected' : ''}`}
                                        onClick={() => handleAnimationClick(name)}
                                        title={name}
                                    >
                                        <div className="vayu-blocks-panel-ihover"></div>
                                        <span className="vb-name-hover">{name}</span>
                                    </div>
                                )
                            ))}

                        </HStack>
                    </VStack>
                </Popover>
            )}
        </div>
    );
};


// "advAnimation":{
//     "type":"object",
//     "default":{
//         "aniName": "none",
//         "className":""
//     }
// }

//  <VayuBlocksAdvAniMation
//     animationData={{dataKey:"advAnimation", value: attributes.advAnimation}}
//     onChange={(key, value) => {setAttributes({ [key]: value });}}
// />
